import { createNamespace } from './helper';

export * from './Shared';

export const SKL_NAMESPACE = 'https://skl.ai/';
export const SKL_DATA_NAMESPACE = 'https://skl.ai/d/';
export const SKL_ENGINE_NAMESPACE = 'https://skl.ai/skl-engine/';

export const SKL_SPECS = createNamespace(SKL_NAMESPACE, [
  'Capability',
  'CapabilityMapping',
  'TriggerCapabilityMapping',
  'integration/InvalidTokenErrorMatcher',
  'JsonDataSource',
  'Mapping',
  'Inputs',
  'OpenAPI',
  'CodeBlock',
  'integration/AuthenticationCredential',
  'integration/IntegrationInterface'
]);

export const SKL_PROPERTY = createNamespace(SKL_NAMESPACE, [

  // Review
  'capabilityType',

  // Updated
  'capability',
  'inputs',
  'outputs',
  'inputsContext',
  'outputsContext',

  'integration/invalidTokenErrorMatcher',
  'integration/invalidTokenErrorMatcherStatus',
  'integration/invalidTokenErrorMatcherMessageRegex',
  'integration/refreshCapability',
  'integration/credential/refreshToken',
  'integration/credential/jwtBearerOptions',
  'integration/credential/accessToken',
  'integration/credential/bearerToken',
  'integration/username',
  'integration/password',
  'integration/oneTimePassword',
  'integration/apiKey',
  'integration/declarativeApiDescription',
  'integration/overrideBasePath',
  'integration/schemeName',
  'integration/oauthFlow',
  'integration/stage',
  'operationId',

  'data',
  'source',
  'dataSource',
  'headers',
  'object',

  'mapping/series',
  'mapping/parallel',
  'mapping/inputsReference',
  'mapping/inputsMapping',
  'mapping/inputsMappingFrame',
  'mapping/inputsMappingRef',
  'mapping/inputsMappingFrameRef',
  'mapping/outputsMapping',
  'mapping/outputsMappingFrame',
  'mapping/preProcessingMapping',
  'mapping/preProcessingMappingFrame',
  'mapping/operationMapping',

  'type',
  'dateTimeCreated',
  'dateTimeModified',
  'label',
  'identifier',
  'content/codeBody',
  'integration/integration',
  'accountOrUser',
  'content/codeBlocks'
]);

// Export const SKLSO_INTEGRATION_NAMESPACE = 'https://skl.so/integration/';
// Export const SKLSO_INTEGRATION = createNamespace(SKLSO_INTEGRATION_NAMESPACE, [
// 'integration',
// 'account',
// 'credential',
// 'interface',
// 'username',
// 'AuthenticationCredential',
// ]);

// export const SKLSO_INTEGRATION_INTERFACE_NAMESPACE = 'https://skl.so/integration/interface/';
// export const SKLSO_INTEGRATION_INTERFACE = createNamespace(SKLSO_INTEGRATION_INTERFACE_NAMESPACE, ['RESTfulApi']);

export const SKL_ENGINE = createNamespace(SKL_ENGINE_NAMESPACE, [
  'update',
  'findAll',
  'findAllBy',
  'find',
  'findBy',
  'exists',
  'existsResult',
  'count',
  'countResult',
  'save',
  'destroy'
]);
